import fixture from './Announcements.get.json';
import { fetchFixture } from 'utils/fetchFixture';
import { API_LOCATION_URL } from 'infrastructure/config';
import { type IAnnouncementTargetType } from 'domain/entities/Announcement/Announcement';
import { type IAnnouncementsClient, type IGetResponse } from 'interfaceAdapter/gatewaySchemas/IAnnouncementsClient';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');

export class AnnouncementsClient implements IAnnouncementsClient {
    async get(params?: {
        offset?: number;
        limit?: number;
        target_type?: IAnnouncementTargetType;
        mock?: boolean;
    }): Promise<IGetResponse> {
        const { mock = false } = params || {};

        const method = 'GET';
        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
        };

        const queryParams = new URLSearchParams();
        if (params?.offset) {
            queryParams.append('offset', params.offset.toString());
        }
        if (params?.limit) {
            queryParams.append('limit', params.limit.toString());
        }
        if (params?.target_type) {
            queryParams.append('target_type', params.target_type);
        }
        const queryString = queryParams.toString();
        const PATH = `${API_LOCATION_URL}/public/announcements${queryString ? `?${queryString}` : ''}`;

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }

        try {
            const response = mock
                ? await fetchFixture(fixture)
                : await fetch(PATH, {
                      method,
                      headers,
                  });
            return response.json();
        } catch {
            throw new Error('お知らせの取得に失敗しました');
        }
    }
}
